import { Injectable } from "@angular/core";
import { AppConfiguration } from "../../config";
import { EncryptionSerProvider } from "../common/encryption";
import { StorageService } from "../common/storage/storage.service";
import { GlobalState } from "../common/app/global/app.global";
import { INVARIANT } from "../../config";
import { Observable } from "rxjs";

/**
 * 指纹验证类
 * iOS Android
 */
@Injectable()
export class FingerPrintHelper {
  private callback: Function;
  private secret: string = "1234567789";
  private platform: string;
  private cipherMode: string = "encrypt";
  private dialogMessage: string;

  constructor(
    private appConfig: AppConfiguration,
    private encryptSer: EncryptionSerProvider,
    private storageSer: StorageService,
    private globalData: GlobalState,
  ) {
    this.platform = this.appConfig.getPlatform();
    console.log(this.globalData);
  }

  /**
   * Fingerprint Availability
   */
  // public isFingerprintAvailable(callback: Function): void {
  //   this.callback = callback;
  //   if (this.platform === 'android') {
  //     this.fingerprintAuth.isAvailable().then(res => {
  //       this.fpAuthIsAvailableSuccess(res);
  //     }, err => {
  //       this.fpAuthIsAvailableError(err);
  //     });
  //   } else if (this.platform === 'ios') {
  //     this.touchId.isAvailable().then(res => {
  //       this.touchIdIsAvailableSuccess(res);
  //     }, err => {
  //       this.touchIdIsAvailableError(err);
  //     });
  //   }
  // }

  /**
   * Android设备指纹功能【可用】的callback方法
   * @param result
   */
  private fpAuthIsAvailableSuccess(result): void {
    console.log("FingerprintAuth available: " + JSON.stringify(result));
    this.callback(null, result);
  }

  /**
   * Android设备指纹功能【不可用】的callback方法
   * @param error
   */
  private fpAuthIsAvailableError(error): void {
    console.log("fpAuthIsAvailableError(): " + error);
    this.callback(error);
  }

  /**
   * iOS设备指纹功能【可用】的callback方法
   * @param result
   */
  private touchIdIsAvailableSuccess(result): void {
    console.log("TouchId available: " + JSON.stringify(result));
    result = { isAvailable: true };
    this.callback(null, result);
  }

  /**
   * iOS设备指纹功能【可用】的callback方法
   * @param error
   */
  private touchIdIsAvailableError(error): void {
    console.log("TouchId error: " + JSON.stringify(error));
    this.callback(error.localizedDescription);
  }

  // End

  /**
   * 开启指纹功能
   * 根据平台判断
   * Android: 分加密和解密
   * iOS:直接开启认证
   * @param options
   * @param callback
   */
  // public authenticate(options: {
  //   secret: string,
  //   mode?: string,
  //   ios?: {
  //     message?: string
  //   }
  // }, callback: Function): void {
  //   this.callback = callback;
  //   this.secret = options.secret;
  //   if (options.ios) {
  //     this.dialogMessage = options.ios.message;
  //   }

  //   if (options.mode) {
  //     this.cipherMode = options.mode;
  //   }
  //   if (this.platform === 'android') {
  //     this.androidAuthentication();
  //   } else if (this.platform === 'ios') {
  //     this.iosAuthentication();
  //   }
  // }

  /**
   * 开启Android指纹功能
   */
  // private androidAuthentication(): void {
  //   this.fingerprintAuth.isAvailable().then(res => {
  //     this.androidAuthIsAvailableSuccess(res);
  //   }, err => {
  //     this.androidAuthIsAvailableError(err);
  //   });
  // }

  /**
   * 开启iOS指纹功能
   */
  // private iosAuthentication(): void {
  //   this.touchId.isAvailable().then(res => {
  //     this.iosAuthIsAvailableSuccess(res)
  //   }, err => {
  //     this.iosAuthIsAvailableError(err)
  //   });
  // }

  /**
   * Android【认证成功】的callback
   * @param result
   */
  // private androidAuthIsAvailableSuccess(result): void {
  //   if (result.isAvailable) {
  //     var config = {
  //       clientId: 'cn.neusoft.mdp.financial',
  //       username: 'kingna',
  //       password: '123456',
  //       token: this.secret,
  //       locale: 'zh_CN'
  //     };
  //     if (this.cipherMode === 'encrypt') {
  //       // 开启指纹认证
  //       this.fingerprintAuth.encrypt(config).then(res => {
  //         this.fpAuthEncryptSuccess(res);
  //       }, err => {
  //         this.fpAuthEncryptError(err);
  //       });
  //     } else if (this.cipherMode === 'decrypt') {
  //       // 验证指纹是否正确（登录时）
  //       this.fingerprintAuth.decrypt(config).then(res => {
  //         this.fpAuthDecryptSuccess(res);
  //       }, err => {
  //         this.fpAuthDecryptError(err);
  //       });
  //     }
  //   } else {
  //     this.callback(null, result);
  //   }
  // }

  /**
   * Android指纹认证失败的callback
   * @param message
   */
  private androidAuthIsAvailableError(message): void {
    this.callback(message);
  }

  /**
   * iOS指纹认证成功
   * @param result
   */
  // private iosAuthIsAvailableSuccess(result): void {
  //   this.touchId.verifyFingerprint(this.dialogMessage).then(res => {
  //     this.touchIdVerifySuccess(res);
  //   }, err => {
  //     this.touchIdVerifyError(err);
  //   });
  // }

  /**
   * iOS认证失败
   * @param error
   */
  private iosAuthIsAvailableError(error): void {
    this.callback(error.localizedDescription);
  }

  /**
   * Android加密成功
   * @param result
   */
  private fpAuthEncryptSuccess(result): void {
    this.callback(null, result);
  }

  /**
   * Android加密失败
   * @param message
   */
  private fpAuthEncryptError(message): void {
    this.callback(message);
  }

  /**
   * Android解密成功
   * @param result
   */
  private fpAuthDecryptSuccess(result): void {
    this.callback(null, result);
  }

  /**
   * Android解密失败
   * @param message
   */
  private fpAuthDecryptError(message): void {
    this.callback(message);
  }

  /**
   * iOS认证成功
   * @param message
   */
  private touchIdVerifySuccess(result): void {
    result = { success: true };
    this.callback(null, result);
  }

  /**
   * iOS认证失败
   * @param error
   */
  private touchIdVerifyError(error): void {
    this.callback(error.localizedDescription);
  }
  // End

  /**
   * 存储手势密码
   * @param pattern 手势密码
   */
  public setLocalGesture(pattern: string): Observable<any> {
    return Observable.create((observe) => {
      const userId = this._userinfo()[INVARIANT._USERID];
      pattern = this.encryptSer.jiamBase(pattern);
      this.storageSer
        .setStore(userId + INVARIANT._USER_FINGER_GESER, pattern)
        .then((res) => observe.next(res));
    });
  }

  /**
   * 清除手势密码
   */
  public clearLocalGesture(): Promise<any> {
    const userId = this._userinfo()[INVARIANT._USERID];
    return this.storageSer.removeStore(userId + INVARIANT._USER_FINGER_GESER);
  }

  /**
   * 获取手势密码
   */
  public getLocalGesture(isJudge?): Observable<any> {
    return Observable.create((observe) => {
      const userId = this._userinfo()[INVARIANT._USERID];
      console.log(userId);
      this.storageSer
        .getStore(userId + INVARIANT._USER_FINGER_GESER)
        .then((res) => {
          console.log(res);
          if (res == null) {
            if (isJudge) {
              observe.next(false);
              observe.complete();
            }
            observe.error();
          } else {
            if (isJudge) {
              observe.next(true);
            } else {
              observe.next(this.encryptSer.jiemBase(res));
            }
            observe.complete();
          }
        });
    });
  }

  /**
   * 设置是否使用指纹
   * @param isUse 是否启用指纹
   */
  public setUseTouchid(isUse: boolean): Observable<any> {
    return new Observable((observe) => {
      const userId = this._userinfo()[INVARIANT._USERID];
      this.storageSer
        .setStore(userId + INVARIANT._USER_USE_TOUCHID, isUse)
        .then((res) => {
          observe.next(res);
          observe.complete();
        });
    });
  }

  /**
   * 获取是否使用指纹
   * @param userAccount 用户id ???
   */
  public getUseTouchid(): Observable<any> {
    return new Observable((observe) => {
      const userId = this._userinfo()[INVARIANT._USERID];
      this.storageSer
        .getStore(userId + INVARIANT._USER_USE_TOUCHID)
        .then((res) => {
          if (res == null) res = false;
          observe.next(res);
          observe.complete();
        });
    });
  }

  private _userinfo() {
    return this.globalData.state.userInfo;
  }
}



// WEBPACK FOOTER //
// ./src/services/common/fingerprint-helper.ts